import {
    focus,
    KeyboardNavigator as IKeyboardNavigator,
    KeyKeyCodeMap,
    ResultAction,
} from '../common/keyboard.model';

export class KeyboardNavigator implements IKeyboardNavigator {
    getCollapse: () => boolean;
    setCollapse: (value) => void;
    getDismiss: () => boolean;
    dismiss: ($event: KeyboardEvent) => void;
    undo: ($event: KeyboardEvent) => void;
    private _bodyTimeout: number;
    private _dismissTimeout: number;

    constructor(private readonly _root: HTMLElement) {}

    _handleEvent($event: KeyboardEvent): ResultAction {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const el = <HTMLElement>$event.target;
        if (!el) return ResultAction.IGNORE;

        if (
            $event.keyCode === KeyKeyCodeMap.Enter ||
            $event.keyCode === KeyKeyCodeMap.Space
        ) {
            if (el === this._root) {
                this.setCollapse(false);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
                const next = <HTMLElement>(
                    this._root.querySelector('[notificationBody]')
                );
                clearTimeout(this._bodyTimeout);
                this._bodyTimeout = window.setTimeout(
                    () => focus(null, next),
                    200,
                );
                return ResultAction.BOTH;
            }
            if (
                el.classList.contains('cmps-notification-dismiss') ||
                el.classList.contains('cmps-notification-undo')
            ) {
                if (!this.getDismiss()) {
                    this.dismiss($event);
                } else {
                    this.undo($event);
                }
                clearTimeout(this._dismissTimeout);
                this._dismissTimeout = window.setTimeout(() => {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
                    const next = <HTMLElement>(
                        this._root.querySelector(
                            !this.getDismiss()
                                ? '.cmps-notification-dismiss'
                                : '.cmps-notification-undo',
                        )
                    );
                    focus(null, next);
                }, 200);
                return ResultAction.BOTH;
            }
        }

        if ($event.keyCode === KeyKeyCodeMap.Escape) {
            if (!this.getCollapse()) {
                focus(el, this._root);
                this.setCollapse(true);
                return ResultAction.BOTH;
            }
        }

        if ($event.keyCode === KeyKeyCodeMap.ArrowLeft) {
            focus(el, this._root);
            return ResultAction.BOTH;
        }

        if ($event.keyCode === KeyKeyCodeMap.ArrowRight) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
            const next = <HTMLElement>(
                el.querySelector(
                    !this.getDismiss()
                        ? '.cmps-notification-dismiss'
                        : '.cmps-notification-undo',
                )
            );
            if (next) {
                focus(null, next);
                return ResultAction.BOTH;
            }
        }

        return ResultAction.IGNORE;
    }

    handleEvent($event: KeyboardEvent): void {
        const ret = this._handleEvent($event);
        switch (ret) {
            case ResultAction.NO_PROPAGATE:
                $event.stopPropagation();
                break;
            case ResultAction.NO_DEFAULT:
                $event.preventDefault();
                break;
            case ResultAction.BOTH:
                $event.stopPropagation();
                $event.preventDefault();
        }
    }

    onFocusInOut($event: FocusEvent): void {
        Array.from(
            this._root.querySelectorAll(
                '.cmps-notification-dismiss, .cmps-notification-undo, [notificationBody]',
            ),
        )
            // eslint-disable-next-line no-return-assign
            .forEach(
                (value: HTMLElement) =>
                    (value.tabIndex = $event.type === 'focusin' ? 0 : -1),
            );
    }
}
